module.exports = __webpack_public_path__ + "img/vue1-corpsarr_rouge.117caaa4.png";